import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import configureStore from "./store/state";
import './index.css';
import ScreensRoot from './screens/root';

const renderApp = preloadedState => {
    const store = configureStore(preloadedState);
    render(
        <Provider store={store}>
            <BrowserRouter>
                <ScreensRoot/>
            </BrowserRouter>
        </Provider>,
        document.querySelector('#root')
    )
};


(() => renderApp())();